import styles from './spinner.module.css'

type Props = {
    size?: 's' | 'm' | 'l'
    label?: string
    centered?: boolean
}

export const Spinner = (props: Props) => {
    const { size, label, centered = true } = props
    
    const sizeClass = size === 'l' ? styles.large : (size === 'm' ? styles.medium : styles.small)
    const centeredClass = centered ? styles.centered : ''

    return (
        <div className={`${styles.container} ${sizeClass} ${centeredClass}`}>
            <div className={`spinner-grow text-primary ${styles.spinner}`} role="status" />
            <span className={styles.label}>{label || 'Cargando...'}</span>
        </div>
    )
}
